import React from 'react';
import { t } from 'Src/i18n';

export const ScheduleEnvelopeFSS = ({ isFullStaySchedule, InputComp }) => {
  if (isFullStaySchedule) {
    return (
      <div className="flex w-full flex-col pt-20">
        <span className="pb-5 text-14 font-bold text-black">
          {t('booking.activities.childcare.chooseWhenFullStay')}
        </span>
        <InputComp />
      </div>
    );
  }
  return <InputComp />;
};
